import React from "react";
import { useParams, Link } from "react-router-dom";
import ReactPlayer from 'react-player';
import styles from "../styles/watchVideo.module.css";
import S3_BUCKET_URL from "../utils/constants"

const WatchVideo = () => {
    const { video_name } = useParams();  // Extract video name from URL

    return (
        <div className={styles.qr_code_container}>
            <div className={styles.video_wrapper}>
                <ReactPlayer
                    url={`${S3_BUCKET_URL}videos/${video_name}.mp4`}
                    controls
                    playing={true}
                    // muted={true}
                    width="100%"
                    height="auto"
                />
            </div>
        </div>
    );
};

export default WatchVideo;
